module.exports = __webpack_public_path__ + "static/media/2alcatel.b64d96f1.png";